import React from 'react';

export default function SplashScreen() {
    return (
        <svg
            viewBox="0 0 305 305"
            style={{
                width: '100px',
                height: '100px',
                position: 'absolute',
                left: '50%',
                top: '50%',
                marginLeft: '-50px',
                marginTop: '-50px',
            }}
        >
            <g fill="#D8D8D8">
                <path d="m60.983 34.249v137c0 8.1066 6.8257 14.678 15.246 14.678 8.4199 0 15.246-6.5717 15.246-14.678v-137c0-8.1066-6.8257-14.678-15.246-14.678-8.4199 0-15.246 6.5717-15.246 14.678z" />
                <path d="m182.95 53.821v137c0 8.1066 6.8257 14.678 15.246 14.678 8.4199 0 15.246-6.5717 15.246-14.678v-137c0-8.1066-6.8257-14.678-15.246-14.678-8.4199 0-15.246 6.5717-15.246 14.678z" />
                <path d="m121.97 14.678v137c0 8.1066 6.8257 14.678 15.246 14.678s15.246-6.5717 15.246-14.678v-137c0-8.1066-6.8257-14.678-15.246-14.678s-15.246 6.5717-15.246 14.678z" />
                <path d="m283.05 206.95l-128.69 59.657c-42.99 19.928-94.619 2.5305-115.32-38.859-5.6294-11.257-8.5527-23.59-8.5527-36.084v-108.49c0-8.1066-6.8257-14.678-15.246-14.678-8.4199 0-15.246 6.5717-15.246 14.678l-3.6109e-14 108.49c2.2568e-15 16.903 3.955 33.589 11.571 48.819 28.004 55.998 97.856 79.536 156.02 52.574l128.69-59.657c7.5864-3.5168 10.775-12.289 7.1226-19.593-3.6527-7.3041-12.764-10.374-20.35-6.8575z" />
            </g>
        </svg>
    );
}
